import axios from 'axios'

export const userService = {
  // Метод для регистрации/авторизации пользователя
  register(userData) {
    // Преобразуем данные в FormData для отправки
    const formData = new FormData()
    for (const key in userData) {
      formData.append(key, userData[key])
    }
    
    return axios.post('/api/user/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  // Метод для выхода пользователя
  logout(uuid) {
    const formData = new FormData()
    formData.append('uuid', uuid)
    
    return axios.post('/api/user/logout/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}